






import { Component, Prop, Vue } from 'vue-property-decorator'
import {getSchoolList} from "@/apis/login/login";

@Component
export default class SchoolSearch extends Vue{
  private schoolList:Array<any>;
  private schoolListShow: Array<any>
  constructor() {
    super();
    this.schoolList = [];
    this.schoolListShow = []
  }
  created() {
    this.$setNavInfo({
      type: "search",
      searchConfig: {
        searchCallbackTiming: "keydown",
        searchCallback: (v) => {
          this.search(v)
        }
      },
      btnGroup: []
    })
    getSchoolList().then(res => {
      this.schoolListShow = this.schoolList = res;
    })
  }
  search(word:string) {
    this.schoolListShow = this.schoolList.filter((item) => {
      return new RegExp(word).test(item)
    })
  }
  confirmSchool(word:string) {
    window.sessionStorage.setItem('selectedSchoolName', word);
    this.$router.back();
  }
}
